"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  props: ['type', 'pageData'],
  data: function data() {
    return {};
  }
};
exports.default = _default;